import type { components } from "@/api/schema";

import type { Marketplace, ReturnRec } from "./types";

export type RawReturnRec = components["schemas"]["Return"];

function toNumber(s?: string): number {
  const n = Number(s);
  return Number.isFinite(n) ? n : 0;
}

/** Map a backend /v1/returns row into the `ReturnRec` view-model. */
export function toReturnRec(r: RawReturnRec): ReturnRec {
  return {
    order: r.order_id,
    ret: r.return_id,
    mkp: r.marketplace as Marketplace,
    seller: r.seller,
    shopId: r.shop_id ?? "",
    reason: r.reason_text,
    refund: toNumber(r.refund_amount),
    status: r.return_status,
    updated: r.mkp_updated_at ?? "",
    tracking: r.tracking_number || null,
    items: (r.items ?? []).map((i) => ({
      sku: i.sino_sku,
      q: i.qty,
      price: toNumber(i.item_price),
    })),
  };
}
